module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Airplay-video-5fd450662f2e5566c58c966534fe97d5.svg";